import {useEffect} from "react";
// Import Global Contexts
import { CalculatorContextProvider } from './contexts/CalculatorContext';
// Import Components
import Calculator from "./components/Calculator";
import History from "./components/History";
import MenuLeft from "./components/MenuLeft";
import ModalForm from "./components/ModalForm";
// Import Functions
import btnLinks from "./functions/btnLinks";
// Import Elements
import BackgroundAnimation from "./elements/BackgroundAnimation";

function App() {

   useEffect(() => {
      /* Call utils functions */
      btnLinks();

      /* Adding Cognito */
      const cognitoScript = document.createElement('script');
      cognitoScript.src = "https://www.cognitoforms.com/f/seamless.js";
      cognitoScript.setAttribute("data-key", "Ed7O2QSPVUKsOPzSWj8VOw");
      cognitoScript.async = true;
      document.getElementsByTagName("body")[0].appendChild(cognitoScript);

    }, []);


    

return (
   <CalculatorContextProvider>
      <div className="calculator-app">
         <Calculator />
         <History />
      </div>
      <ModalForm />
      <MenuLeft />
      <BackgroundAnimation />
   </CalculatorContextProvider>
);
}

export default App;
